import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { ROUTES } from "@/app/constants";

export default function AuthGuard() {
    const { user, loading } = useAuthStore();
    const location = useLocation();

    if (loading)
        return (<p>loading...</p>)

    if (!user)
        return <Navigate to="/login" replace />;

    /**
     * Clients created before 2026-08-22 were allowed to register without
     * confirming their mobile number, so 36 of the 38 client accounts carry
     * phone_verified = false. Registration now requires it; these are the
     * backlog, and the owner's decision is that they verify at next login.
     *
     * The gate is HERE rather than on individual screens because AuthGuard is
     * the single choke point every authenticated route already passes through
     * — putting it on the portal alone would leave every other route open, and
     * putting it on each route is how one gets missed.
     *
     * STAFF ARE NOT GATED. Both staff accounts also read phone_verified =
     * false, and locking the two administrators out of the CRM to enforce a
     * client-facing signup rule would be an own goal — the rule exists because
     * clients self-register, which staff do not.
     *
     * The verify screen itself must stay reachable or this is a closed loop,
     * hence the path check. Sign-out stays reachable too: it is not behind
     * AuthGuard.
     */
    const needsPhoneVerification =
        user.role === "CLIENT" && user.phoneVerified === false;

    if (needsPhoneVerification && location.pathname !== ROUTES.verifyPhone) {
        return <Navigate to={ROUTES.verifyPhone} replace />;
    }

    return <Outlet />;
}
